module.exports = __webpack_public_path__ + "img/head-banner4.6d4b780e.png";